import { Controller } from "@hotwired/stimulus"
import React from "react"
import ReactDOM from "react-dom/client"
import ClaimNFTPage from "../components/claim-nft-page"

export default class extends Controller {

  connect() {
    this.root = ReactDOM.createRoot(this.element)
    this.root.render(
      <ClaimNFTPage/>
    )
  }

  disconnect() {
     this.root.unmount()
  }
  
}
